<template>
  <div>
    <form id="formSiteSetupWatermarks" @change="clearErrors()" class="d-flex flex-column"  v-on:submit.prevent="updateWatermarksSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Watermarks</h5>
                  <div class="element-inner-desc">Here you can change the Watermark settings.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'stamp']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Watermarks</h5>
                  <div class="element-inner-desc">Here you can change the Watermark settings.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="row">
            <b-form-group class="mt-3 col-lg-8 col-sm-12">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupWatermarks.on_by_default"
                  name="on_by_default"
                  :value="1"
                  :unchecked-value="0">
                  On by default (Only applies to invoices)
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-4 col-sm-12">
              <b-input-group>
                <p class="col-sm-12">
                  <span class="col-sm-12">Delay in showing default (hours)</span>
                  <b-form-input class="col-lg-3 col-sm-12 mx-2 d-inline-block" v-model="setupWatermarks.delay_for"></b-form-input>
                </p>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Default Watermark</h5>
              <h5 v-else class="py-2 text-center">Default Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_default"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_default ? setupWatermarks.path_to_default.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - Default Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">True and Certified Watermark</h5>
              <h5 v-else class="py-2 text-center">True and Certified Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_trueandcertified"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_trueandcertified ? setupWatermarks.path_to_trueandcertified.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - True and Certified Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Copy Watermark</h5>
              <h5 v-else class="py-2 text-center">Copy Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_copy"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_copy ? setupWatermarks.path_to_copy.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - Copy Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">STMT Overdue Watermark</h5>
              <h5 v-else class="py-2 text-center">STMT Overdue Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_user1"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_user1 ? setupWatermarks.path_to_user1.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - STMT Overdue Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">STMT Overdue2 Watermark</h5>
              <h5 v-else class="py-2 text-center">STMT Overdue2 Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_user2"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_user2 ? setupWatermarks.path_to_user2.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - STMT Overdue2 Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Approved Watermark</h5>
              <h5 v-else class="py-2 text-center">Approved Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_approved"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_approved ? setupWatermarks.path_to_approved.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - Approved Watermark</b-button>
            </div>
          </div>
          <div class="project-head">
            <div class="project-title">
              <h5 v-if="!this.mobile" class="py-2 element-header">Direct Debit Watermark</h5>
              <h5 v-else class="py-2 text-center">Direct Debit Watermark</h5>
            </div>
          </div>
          <div class="row">
            <b-form-group class="col-lg-6 col-sm-12">
              <b-form-file
                v-model="setupWatermarks.path_to_directdebit"
                placeholder="Choose a file or drop it here"
                drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-1">Selected file: {{ setupWatermarks.path_to_directdebit ? setupWatermarks.path_to_directdebit.name : '' }}</div>
            </b-form-group>
            <div class="col-lg-6 col-sm-12 align-self-center">
              <b-button class="float-right col-lg-7">Preview - Direct Debit Watermark</b-button>
            </div>
          </div>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupWatermarks'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupWatermarks',
  components: {
    ResponseInfo,
    ValidationErrors
  },
  data() {
    return {
      setupWatermarks: {},
      mobile: window.innerWidth <= 700
    }
  },
  created() {
      watermarksSettings:{
          this.$store.dispatch('getWatermarksSettings')
          .then(() => {
              if(Object.keys(this.watermarksSettings).length){
                  this.setupWatermarks = Object.assign({}, this.watermarksSettings)
              }
          })
      }
      window.addEventListener('resize', () => {
            this.mobile = window.innerWidth <= 700
      })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet','getWatermarksSettings','getResponseInfo']),
      watermarksSettings:{
          get() {
              return this.$store.getters.getWatermarksSettings
          }
      }
  },
  methods: {
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updateWatermarksSettings(){
      this.$store.dispatch('setWatermarksSettings',{
          data: this.setupWatermarks
      })
    }
  }
}
</script>

<style lang="css" scoped>
.tab-card-form{
  min-width: 70%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
